import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import HiddenLoader from '@fuww/library/src/HiddenLoader';
import withQuery from '../../../lib/withQuery';
import JobLinks from './JobLinks';
import messages from '../../../lib/messages.json';
import latestJobsQuery from '../../../lib/queries/jobs/latestJobsQuery.graphql';
import { useSiteContext } from '../../SiteContext';

export const latestJobsImageUrls = {
  sidebar: [
    'https://r.fashionunited.com/wzB73c2waVKhGuqdVlPm8I4V2Kt652RBYPY_8WAEW0I/resize:fill:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/-wRWzj2AfEzvsHnC3GyhEUUeUkc-gAnrPCl_TNbSwBY/resize:fill:311:208:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/H0UwHmvLCJvsEJ_5kczwBki94N8FZkAVc57of1reRGE/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/jQ3XUIfMmbaQbt2JPdVTqeHrYsrsJ6lua8RkqaqUqXE/resize:fill:567:378:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/-KVVrTm69jOUOVokBw9b9SefdJSKXbEGF3jjQlP_lGw/resize:fill:656:438:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/8MaT-wkIWj6n_v8-lzmQNzGrEvwPrwQN_APPQnxOibM/resize:fill:744:496:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/LoqIZ0V06fK0mPQ6oVmyckjHZ77U7l2IrKcOy_Zf3hU/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/M_-4jM5HOmIRGF5zhu5YLBNqS4M3TXQcvkZrsiDDMDo/resize:fill:1134:756:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
  ],
  main: [
    'https://r.fashionunited.com/wzB73c2waVKhGuqdVlPm8I4V2Kt652RBYPY_8WAEW0I/resize:fill:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/MiP75TLIaNcx82VWq0et736bHX8o9ikUXCqBFVvxupg/resize:fill:330:220:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/Wdqyb30ZpqWP207WoQa0VWAqHywBt6XiLaCMXjD7Kzg/resize:fill:660:440:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
    'https://r.fashionunited.com/h1K5c5YlQY5hGyf5702Ej6OM3YKwy-Jls6ZvaP6_FIQ/resize:fill:720:480:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGF0ZXN0Sm9ic0ltYWdlLnBuZw',
  ],
};

const LatestJobs = ({
  data,
  title,
  categoryParam,
  placeholder,
  src,
  srcSet,
  sizes,
}) => {
  const intl = useIntl();

  return (
    <JobLinks
      title={title || intl.formatMessage(messages.latestJobs)}
      className="highlight"
      jobs={data.jobs}
      categoryParam={categoryParam}
      placeholder={placeholder}
      src={src}
      srcSet={srcSet}
      sizes={sizes}
    />
  );
};

LatestJobs.propTypes = {
  data: PropTypes.shape({
    jobs: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  title: PropTypes.string,
  categoryParam: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
};

LatestJobs.defaultProps = {
  data: {},
  title: null,
  categoryParam: null,
};

const LatestJobsWithQuery = withQuery(LatestJobs);

const LatestJobsWithData = ({
  variables,
  title,
  categoryParam,
  placeholder,
  src,
  srcSet,
  sizes,
}) => {
  const { jobsLocale } = useSiteContext();
  const mostReadVariables = {
    locales: jobsLocale,
    offset: 0,
    limit: 3,
    ...variables,
  };

  return (
    <LatestJobsWithQuery
      query={latestJobsQuery}
      variables={mostReadVariables}
      errorMessage="Error while loading jobs..."
      title={title}
      categoryParam={categoryParam}
      placeholder={placeholder}
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      loader={<HiddenLoader />}
    />
  );
};

LatestJobsWithData.propTypes = {
  variables: PropTypes.shape({}),
  title: PropTypes.string,
  categoryParam: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
};

LatestJobsWithData.defaultProps = {
  variables: {},
  title: null,
  categoryParam: null,
};

export default LatestJobsWithData;
